var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-nav", class: [_vm.bemFacets, _vm.rootFacets] },
    [
      _c("navbar", {
        ref: "mainNavBar",
        attrs: {
          items: _vm.items,
          "brand-logo": _vm.brandLogoBlack,
          "brand-logo-alt": _vm.brandLogoAlt
        }
      }),
      _vm._v(" "),
      _c(
        "scroll-reveal",
        {
          staticClass: "main-nav--scroll-reveal",
          attrs: { "element-class": "reduced-nav" }
        },
        [
          _c("navbar", {
            attrs: {
              facets: ["reduced"],
              items: _vm.items,
              "brand-logo": _vm.brandLogoBlack,
              "brand-logo-alt": _vm.brandLogoAlt
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22876af8", { render: render, staticRenderFns: staticRenderFns })
  }
}